import axios from '@/plugins/axios';

const FORGOT_PASSWORD = '/forgot-password';
const VERIFY_TOKEN_FORGOT_PASSWORD = '/reset';
export const RESET_PASSWORD = '/reset-password';

export async function forgotPassword(payload) {
  try {
    const data = await axios.post(`${FORGOT_PASSWORD}`, payload);
    return data;
  } catch (error) {
    return { error };
  }
}

export async function verifyForgotPassword(payload) {
  try {
    const { data } = await axios.get(`${VERIFY_TOKEN_FORGOT_PASSWORD}/${payload.token}`);

    return data;
  } catch (error) {
    return { error };
  }
}

export async function resetPassword(payload) {
  try {
    const { data } = await axios.post(`${RESET_PASSWORD}/${payload.token}`, payload);

    return data;
  } catch (error) {
    return { error };
  }
}
